import { render, staticRenderFns } from "./DDocumentEditor.vue?vue&type=template&id=d03ecbf8&"
import script from "./DDocumentEditor.vue?vue&type=script&lang=js&"
export * from "./DDocumentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports